//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { requiredIf } from 'vuelidate/lib/validators';
import { isValidArray, stringToNumber } from '@razlet/utils';
import {
  float, int, positive, optional,
} from '~/validators';
import form from '~/mixins/components/form';
import Methods from '~/api/methods/shipment';
import { autocompleteManager } from '~/services/autocomplete-manager';

export default {
  name: 'booking-cargo-form',
  mixins: [form],
  props: {
    multipleCargoTypes: {
      type: Boolean,
      default: false,
    },
    separateCargoTypes: {
      type: Boolean,
      default: false,
    },
    hideCommodity: {
      type: Boolean,
      default: false,
    },
    hideCargoType: {
      type: Boolean,
      default: false,
    },
    editableCargoTypes: Boolean,
    editableCargoSizes: {
      type: Boolean,
      default: false,
    },
    readonlyCargo: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasDimensions: {
      type: Boolean,
      default: false,
    },
    start: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      cargoTypeFields: [null],
      cargoTypeNames: {},
      airport: null,
      localeKey: 'booking.cargo',
      sender: new Methods(),
      submitPending: false,
      isEditActive: false,
    };
  },
  validations () {
    const dimensionFields = ['pieces', 'weight', 'width', 'height', 'length', 'volume'];
    const totalFields = ['pieces', 'weight', 'volume'];

    const lesserThanTotal = (dim, key) => {
      return optional(dim[key], () => {
        const totalValue = this.request.sumDimensions()[key];

        return stringToNumber(totalValue) <= stringToNumber(this.request[key]);
      });
    };

    const baseRulesDimension = (item) => ({
      requiredIf: requiredIf(val => {
        return this.isRequired || !val.isEmptyDimension();
      }),
      positive: (_, dim) => {
        if (dim.isEmptyDimension()) return true;
        return positive(dim[item]);
      },
      ...(item !== 'volume' && { float }),
      ...(totalFields.includes(item) && {
        lesserThanTotal: (_, dim) => {
          if (dim.isEmptyDimension()) return true;
          return lesserThanTotal(dim[item], item);
        },
      }),
    });

    const dimensionRules = dimensionFields.reduce((acc, item) => {
      acc[item] = baseRulesDimension(item);
      return acc;
    }, {});

    dimensionRules.pieces.int = int;

    return {
      isEditActive: {
        mustBeFalse () {
          return this.isEditActive === false;
        },
      },
      request: {
        pieces: {
          requiredIf: requiredIf(() => {
            return this.request.isBooking || this.request.isRequirements;
          }),
          int,
          positive,
        },
        weight: {
          requiredIf: requiredIf(() => {
            return this.request.isBooking || this.request.isRequirements;
          }),
          float,
          positive,
        },
        volume: {
          requiredIf: requiredIf(() => {
            return this.request.isBooking || this.request.isRequirements;
          }),
          positive,
        },
        commodity: { required: requiredIf(() => this.request.isBooking && !this.request.isPost) },
        dimensions: { $each: dimensionRules },
      },
    };
  },
  computed: {
    selectedCargoType: {
      get () {
        return this.isCabinet && !this.multipleCargoTypes
          ? this.request.shcList?.[0] || null
          : this.request.shcList;
      },
      set (value) {
        if (!this.isCabinet || this.multipleCargoTypes) {
          const codes = value || [];
          if (JSON.stringify(this.request.shcList || []) === JSON.stringify(codes)) {
            return;
          }
          this.request.shcList = codes;
          return;
        }
        // Autocomplete echoes its initial value; preserve additional guided SHC codes.
        if (value === (this.request.shcList?.[0] || null)) {
          return;
        }
        this.request.shcList = value ? [value] : [];
      },
    },
    volumeMask () {
      return this.request.volumeMask;
    },
    classes () {
      return {
        'form booking-cargo-form--post': this.request.isPost,
        'booking-cargo-form--hs': this.isDubaiDirection && !this.request.isPost,
        'booking-cargo-form--readonly': this.readonlyCargo,
        'booking-cargo-form--details-cabinet': !this.start && this.isCabinet,
      };
    },
    isErrorText () {
      return this.$v?.isEditActive?.$dirty && this.$v?.isEditActive?.mustBeFalse === false;
    },
    isRequired () {
      return this.request.isPost && this.request.isBooking;
    },
    dimensionsValidation () {
      if (!this.$v || !this.$v.request) return [];
      return this.$v.request.dimensions.$each;
    },
    isDubaiDirection () {
      return this.request.departure === 'DWC' || this.request.arrival === 'DWC';
    },
    cargoInfoItems () {
      return [
        {
          name: this.label('pieces'),
          value: this.request.pieces,
          unit: this.$t('base.pc'),
        },
        {
          name: this.label('weight'),
          value: this.request.weight,
          unit: this.$t('base.kg'),
        },
        {
          name: this.label('volume'),
          value: this.request.volume,
          unit: this.$t('base.m3'),
        },
      ];
    },
  },
  watch: {
    volumeMask: {
      handler () {
        if ((!this.readonlyCargo || this.editableCargoSizes) &&
          this.request.volume !== '' && this.request.volume != null) {
          this.request.volume = this.request.roundedVolumeValue(this.request.volume);
        }
      },
      immediate: true,
    },
    'request.shcList': {
      deep: true,
      handler (val) {
        this.syncCargoTypeFields();
        this.$emit('shc-change', val);
      },
    },
    'request.weight': {
      handler (value) {
        if (this.request.isPost) {
          this.request.volume = this.request.roundedVolumeValue(stringToNumber(value) / 100);
        }
        if (this.serverErrors?.['cargo.weight']) {
          this.$set(this.serverErrors, 'cargo.weight', null);
        }
      },
    },
    'request.volume' () {
      if (this.serverErrors?.['cargo.volume']) {
        this.$set(this.serverErrors, 'cargo.volume', null);
      }
    },
    'request.dimensions.length': {
      handler (value) {
        if (!value && this.isEditActive) {
          this.triggerEdit();
        }
      },
    },
  },
  mounted () {
    this.loadCargoTypeNames();
  },
  created () {
    this.syncCargoTypeFields();
  },
  methods: {
    async loadCargoTypeNames () {
      if (!this.readonlyCargo || !this.request.shcList?.length) {
        return;
      }
      try {
        const response = await autocompleteManager.get('cargo-type', 'code', 'name', {
          values: this.request.shcList,
          ...(this.request.contractId && { contract: this.request.contractId }),
        });
        this.cargoTypeNames = Object.fromEntries(
          (response.data || []).map(item => [item.code, item.name])
        );
      } catch (_) {
        this.cargoTypeNames = {};
      }
    },
    syncCargoTypeFields () {
      const codes = this.request.shcList || [];
      const selected = [...new Set(this.cargoTypeFields.filter(Boolean))];
      if (JSON.stringify(codes) !== JSON.stringify(selected)) {
        this.cargoTypeFields = codes.length ? [...codes] : [null];
      }
    },
    setCargoType (index, code) {
      this.$set(this.cargoTypeFields, index, code);
      this.request.shcList = [...new Set(this.cargoTypeFields.filter(Boolean))];
    },
    addCargoType () {
      this.cargoTypeFields.push(null);
    },
    removeCargoType (index) {
      if (this.cargoTypeFields.length <= 1) return;
      this.cargoTypeFields.splice(index, 1);
      this.request.shcList = [...new Set(this.cargoTypeFields.filter(Boolean))];
    },
    validateDimensions () {
      this.clearServerValidationErrors();

      const errors = this.validate();
      return errors;
    },
    saveDimensions () {
      this.request.filterEmptyDimensions();
      if (this.editableCargoSizes && this.request.canChangeCargoSizes) {
        this.sumDimensions();
      }
      if (this.validateDimensions()) {
        return;
      }

      this.triggerEdit();
      this.$emit('dimensions-saved');
    },
    sumDimensions () {
      if (this.readonlyCargo && !this.editableCargoSizes) {
        return;
      }
      this.request.filterEmptyDimensions();

      if (this.request.dimensions.length > 0) {
        this.request.fillDimensionsSum();
      }
    },
    validate () {
      this.clearServerValidationErrors();
      this.$v.request.$touch();
      this.request.dimensions.forEach((dimension, i) => {
        this.$v.request.dimensions.$each[i].$touch();
      });
      const errors = this.$v.request.$error;
      if (errors) this.$forceNextTick(() => this.scrollToFirstError());
      return errors;
    },
    validateOnSubmit () {
      if (this.isEditActive) {
        this.$v.isEditActive.$touch();
        this.$forceNextTick(() => this.scrollToFirstError());
        return this.$v.isEditActive.$error;
      }
    },
    additionalHandleServerValidation () {
      if (!isValidArray(this.request.dimensions)) return;
      this.request.dimensions.forEach((_, index) => {
        this.$refs[`dimension-${index}`].serverErrors = this.serverErrors?.dimensions?.[index];
      });
    },
    enterDimensions () {
      this.request.dimensions.push(this.request.createDimension());
      this.triggerEdit();
    },
    triggerEdit () {
      this.isEditActive = !this.isEditActive;

      if (this.isEditActive) {
        this.$v.isEditActive.$reset();
      }
    },
  },
};
